module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/suns_link_image_plan-7f869659737318cc731cf86491115991.jpg";